export { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

let bn = '';

if (ENVIRONMENT === 'local') {
	bn = '';
} else if (ENVIRONMENT === 'dev') {
	bn = '/LandingPage/';
} else if (ENVIRONMENT === 'test') {
	bn = '/LandingPage/';
} else if (ENVIRONMENT === 'prod') {
	bn = '/LandingPage/';
}

export const browserHistory = createBrowserHistory({
	basename: bn
});
